import { Alert, Snackbar, Stack } from "@mui/material";
import { AppAlert } from "./AlertTypes";

interface AlertSnackbarProps {
  alerts: AppAlert[];
  onClose: (id: number) => void;
}

export const AlertSnackbar = ({ alerts, onClose }: AlertSnackbarProps) => (
  <Stack
    spacing={1}
    sx={{
      position: "fixed",
      top: 16,
      right: 16,
      zIndex: 1400,
      pointerEvents: 'none'
    }}
  >
    {alerts.map((alert) => (
      <Snackbar
        key={alert.id}
        open
        autoHideDuration={alert.duration ?? 3000}
        onClose={(_event, reason) => {
          if (reason === 'clickaway') return;
          onClose(alert.id);
        }}
        sx={{
          position: "static",
          pointerEvents: 'auto',
          '& .MuiSnackbar-root': { position: 'static' }
        }}
      >
        <Alert
          severity={alert.severity}
          variant="filled"
          onClose={() => onClose(alert.id)}
          sx={{ width: '100%', minWidth: '300px', boxShadow: 3 }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    ))}
  </Stack>
);
